import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePropriedadeCadastro } from '../service';
import {
  DELETE_PROPRIEDADE_CADASTRO,
  DELETE_PROPRIEDADE_CADASTRO_PENDING,
  DELETE_PROPRIEDADE_CADASTRO_SUCCESS,
  DELETE_PROPRIEDADE_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { MODULE_ACTIONS_ENUM, trackingEventCX } from '@handler/tracking/customerX';

function* sagaDeletePropriedadeCadastro(action) {
  yield put({ type: DELETE_PROPRIEDADE_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.FAZENDAS_EXCLUIR);

  try {
    const a = yield call(deletePropriedadeCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PROPRIEDADE_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PROPRIEDADE_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeletePropriedadeCadastro() {
  yield takeLatest(DELETE_PROPRIEDADE_CADASTRO, sagaDeletePropriedadeCadastro)
}
